import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_edi_export_completed_shipmentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { project_ids?: number[], days?: number, shipment_type?: number, transaction_type?: string, integration_id: string, has_order_transmissions?: boolean }): Promise<void> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.integration_id)) {
      $missingRequiredInParams.push('\'integration_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/app/functions/edi_export_completed_shipments`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

